import { useQuery } from '@tanstack/react-query';
import { migrationService } from '../services/MigrationService';
import type { MigrationStatus } from '../repositories/MigrationRepository';

/**
 * Hook to fetch migration status
 * Checks the status of data migration from legacy tables to primary tables
 */
export function useMigrationStatus() {
  return useQuery<MigrationStatus[]>({
    queryKey: ['migration-status'],
    queryFn: () => migrationService.checkMigrationStatus(),
    staleTime: 60000, // 1 minute cache - migration status doesn't change frequently
  });
}
